import { redirect } from "react-router-dom";

import BaseRoute from "../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../lib/itn-ui-kit/services/service-container";

import Template from "./template";

export default class FollowUpsRoute extends BaseRoute {
  @service landingService;
  @service("repositories/actionable-items-repository") actionableItemRepository;
  @service("repositories/follow-ups-form-repository") followUpFormRepository;
  @service("repositories/follow-ups-list-repository") followUpListRepository;
  @service("repositories/field-option-repository") fieldOptionRepository;

  path = "form/:actionItemId";
  element = (<Template />);

  async loader({ params }) {
    const { actionItemId } = params;

    if (!actionItemId || actionItemId === "undefined") {
      console.error("Action item id not found");
      return redirect("/not-found");
    } else {
      try {
        const actionItem = await this.actionableItemRepository.findRecord(actionItemId);
        const followUpList = await this.followUpListRepository.query({
          actionItemId,
        });
        const fieldOptions = await this.fieldOptionRepository.query({
          content_type: "contactrelation",
          flat: "true",
        });

        // Redirect if there is no form to fetch
        if (!followUpList || followUpList?.length === 0) {
          return redirect("/not-found");
        }

        const formId = followUpList[0]?.uuid || "";
        const followUp = await this.followUpFormRepository.query({
          actionItemId,
          formId,
        });

        return {
          _case: actionItem.onCase,
          followUp,
          caseId: actionItem?.onCase?.id,
          actionItem,
          followUpId: actionItem?.id,
          formId,
          fieldOptions,
        };
      } catch (error) {
        console.error(`Error getting action item: ${actionItemId}`, error);
        return redirect("/not-found");
      }
    }
  }
}
